// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"23e6fea1","380":"1bd42315","599":"23e6fea1","993":"23e6fea1"}[chunkId] + ".chunk.css";
};